(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('VCUserSearch', VCUserSearch);

    VCUserSearch.$inject = ['$resource'];

    function VCUserSearch($resource) {
        var resourceUrl =  'api/_search/vc-users/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
